import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBriefcase, faUser, faLock } from '@fortawesome/free-solid-svg-icons';

export function normalizeTag(tag?: string | null): string | null {
  if (tag) {
    const t = String(tag).toLowerCase();
    // If future mappings need to be customized, or expanded.
    switch (t) {
      case 'business':
        return 'business';
      case 'personal':
        return 'personal';
      case '':
        return null;
      default:
        return t;
    }
  }
  return null;
}


export function getIconForTag(tag: string): IconDefinition {
  const t = normalizeTag(tag);
  if(t === null) {
    return null;
  }
  else {
    switch(t) {
      case 'business':
        return faBriefcase;
      case 'personal':
        return faUser;
      default:
        return faLock;
    }
  }
}

export function getTitleForTag(tag: string): string {
  const t = normalizeTag(tag);
  if(t === null) {
    return null;
  }
  else {
    switch(t) {
      case 'business':
        return "Business";
      case 'personal':
        return "Personal";
      default:
        return tag;
    }
  }
}